export default __webpack_public_path__ + "static/278-72fcf50324f69981b8719e99011c1139.gif";